import React, { useState } from "react"

// Il riepilogo di giugno, che si ricalcola cambiando un dato: chi paga il
// campo delle private, un allievo che paga il circolo invece del maestro, un
// pagamento che mancava. I numeri tornano: il netto è quello da fatturare
// al circolo più gli incassi, meno il costo dei campi.

const COURSES = 738 // scuola tennis, corso adulti e centro estivo, a ore
const PRIVATE = 570 // le private degli altri allievi
const DAVIDE = 120 // tre lezioni di Davide già pagate, 40 € l'una
const DAVIDE_SCHOOL = 120 // le sue 4 ore, a 30 € l'ora, fatturate al circolo
const MISSING = 40 // la lezione di Davide senza metodo di pagamento
const COURTS_PRIVATE = 216 // 18 ore di private a 12 € l'ora
const COURTS_MINE = 42 // le partite di «Gioco io»

const HOURS = [
	{ type: "pri", name: "Privata", text: "18 ore · 9 pers." },
	{ type: "sat", name: "Scuola tennis", text: "12 ore" },
	{ type: "cad", name: "Corso adulti", text: "9 ore" },
	{ type: "ce", name: "Centro estivo", text: "20 ore" },
]

const euro = n => `${n} €`

function DemoMonth() {
	const [courtByMe, setCourtByMe] = useState(true)
	const [davideAtSchool, setDavideAtSchool] = useState(false)
	const [fixed, setFixed] = useState(false)

	const toInvoice = COURSES + (davideAtSchool ? DAVIDE_SCHOOL : 0)
	const cashed = PRIVATE + (davideAtSchool ? 0 : DAVIDE + (fixed ? MISSING : 0))
	const courts = COURTS_MINE + (courtByMe ? COURTS_PRIVATE : 0)
	const net = toInvoice + cashed - courts
	const missing = !davideAtSchool && !fixed

	return (
		<div className="demo demo-month">
			<div className="demo-card">
				<p className="demo-overline">Prova a cambiare</p>
				<div className="demo-month-row">
					<span>
						Il campo delle private
						<small>18 ore × 12 €/h</small>
					</span>
					<span className="demo-paid-by">
						pagato da
						<span className="demo-segment" role="group" aria-label="Il campo è pagato da">
						<button type="button" aria-pressed={courtByMe} className={courtByMe ? "is-on" : ""} onClick={() => setCourtByMe(true)}>
							me
						</button>
						<button type="button" aria-pressed={!courtByMe} className={courtByMe ? "" : "is-on"} onClick={() => setCourtByMe(false)}>
							loro
						</button>
						</span>
					</span>
				</div>
				<hr />
				<button
					type="button"
					className="demo-month-row demo-month-toggle"
					aria-pressed={davideAtSchool}
					onClick={() => setDavideAtSchool(!davideAtSchool)}>
					<span>
						Davide Mancini paga il circolo
						<small>4 private da 1 ora · a te 30 €/h</small>
					</span>
					<span className={`demo-switch is-plain${davideAtSchool ? " is-on" : ""}`} aria-hidden="true">
						<span />
					</span>
				</button>
				{missing && (
					<>
						<hr />
						<div className="demo-month-row">
							<span className="demo-month-missing">
								<span className="demo-warn">!</span>
								<span>
									1 lezione senza pagamento
									<small>Davide, giovedì 11</small>
								</span>
							</span>
							<button type="button" className="demo-chip" onClick={() => setFixed(true)}>
								Contanti, 40 €
							</button>
						</div>
					</>
				)}
			</div>

			<div className="demo-card">
				<div className="demo-month-head">
					<b>Ore di lezione</b>
					<span className="demo-badge is-orange">59 ore</span>
				</div>
				<div className="demo-hours">
					{HOURS.map(h => (
						<span key={h.type} className={`demo-hour type-${h.type}`}>
							<b>{h.name}</b>
							<small>{h.text}</small>
						</span>
					))}
				</div>
			</div>

			<div className="demo-card">
				<div className="demo-month-head">
					<b>Compensi</b>
					<span className="demo-badge">{euro(net)}</span>
				</div>
				<div className="demo-money">
					<span>
						Da fatturare al circolo
						<small>
							{davideAtSchool ? "Corsi, centro estivo e le 4 ore di Davide" : "Scuola tennis, corso adulti, centro estivo"}
						</small>
					</span>
					<b className="is-yellow">{euro(toInvoice)}</b>
				</div>
				<div className="demo-money">
					<span>
						Incassi private
						<small>
							{davideAtSchool
								? "senza Davide: lo paga il circolo"
								: fixed
									? "contanti, Satispay, POS"
									: "contanti, Satispay, POS · 1 da segnare"}
						</small>
					</span>
					<b className="is-green">{euro(cashed)}</b>
				</div>
				<div className="demo-money">
					<span>
						Costo campi
						<small>
							{courtByMe ? "private 216 € · Gioco io 42 €" : "solo Gioco io: le private lo pagano loro"}
						</small>
					</span>
					<b className="is-red">- {euro(courts)}</b>
				</div>
				<div className="demo-net">
					<span>Totale netto</span>
					<b aria-live="polite">{euro(net)}</b>
				</div>
			</div>

			<div className="demo-bar">
				<span className="demo-bar-dates">
					<span>lun 1 giu</span>
					<span>mar 30 giu</span>
				</span>
			</div>
		</div>
	)
}

export default DemoMonth
